
import Module, { bindButtonClickEvent, moduleInit, ViewLayer } from "../../../../framework/core/mvvm/module_base";
import Q2TableResultView from "./q2_table_result_view";

const { ccclass, property, menu } = cc._decorator;

@ccclass
@moduleInit("Q2TableResultModule")
export default class Q2TableResultModule extends Module<Q2TableResultView, null> {

    constructor() {
        super()
        this.initModule(null, null, null)
    }

    protected m_intentData: any

    initModule(viewType, modelType, resPath) {
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = resPath || 'package/q2/q2_table_result';
        this.viewType = viewType || Q2TableResultView;
        this.modelType = modelType;
        this.needViewMask = true
        this.clickAnywhereClose = false
    }


    onShow(data: any) {
        let self = this
        this.m_intentData = data
        this.view.showResultPanel(true, data, true)
        this.view.showDetailPanel(false)
        this.view.showTimeOutSlider(12, 12, function(){
            self.on_click_continue_btn()
        })
    }

    @bindButtonClickEvent('resultCloseBtn')
    protected on_click_leave_btn(){
        this.m_intentData && this.m_intentData.backBtnCallback && this.m_intentData.backBtnCallback()
    }

    @bindButtonClickEvent('continueBtn')
    protected on_click_continue_btn(){
        this.m_intentData && this.m_intentData.continueBtnCallback && this.m_intentData.continueBtnCallback()
    }

    @bindButtonClickEvent('detailBtn')
    protected on_click_detail_btn(){
        this.view.showDetailPanel(true, this.m_intentData)
        this.view.showResultPanel(false)
    }
    
    @bindButtonClickEvent('detailCloseBtn')
    protected on_click_detail_close_btn(){
        this.view.showResultPanel(true, this.m_intentData)
        this.view.showDetailPanel(false)
    }
    
}
